export const SET_MAIL_TO_SEND = 'SET_MAIL_TO_SEND'
export const SET_MAIL_IS_SENT = 'SET_MAIL_IS_SENT'
